<template>
  <v-app>
    <v-content class="mb-8">
      <GlobalNav />
      <v-fade-transition mode="out-in" appear>
        <Router-view />
      </v-fade-transition>
      <GlobalFooter />
    </v-content>
  </v-app>
</template>

<script>
import bulletTrain from 'bullet-train-client'
import store from '@/store'
import GlobalNav from './components/GlobalNav'
import GlobalFooter from './components/GlobalFooter'

export default {
  name: 'Frontpage',
  components: {
    GlobalNav,
    GlobalFooter
  },
  created() {
    bulletTrain.init({
      environmentID: 'o9cZv6LHxZBGDDaqnVU3z5',
      onChange: () => {
        store.commit(
          'flags/SET_SHOW_COPRIGHTNOTICE',
          bulletTrain.hasFeature('show_copyrightnotice_everywhere')
        )
      }
    })
  }
}
</script>
